var StoreWaitBoardModel = require('../../models/wait-board/store-wait-board');
var StoreWaitBoardItemView = require('./store-wait-board-item');

var StoreWaitBoardView = Backbone.Epoxy.View.extend({
  template: 'store-wait-board.storeWaitBoard',
  itemView: StoreWaitBoardItemView,

  /*
  events: {
    'click .js-waitboard-action__waitlist': 'onWaitList',
    'click .js-waitlist-action__book': 'onBookAppointment',
  },
  */

  initialize: function() {

    this.isLoading = true;
    this.dataVersion = 0;
    this.renderVersion = -1;

    this.waitTimer = null;
    this.model = new StoreWaitBoardModel();
    this.collection = this.model.get('waitBoardItems');
  },

  refresh: function() { // called from logout function when available
    this.setData();
  },

  setData: function(parameters, viewName) {
    this.store = parameters.store;
    this.disposeWaitTimesTimeout = false;
    //TODO:: store selection
    this.setWaitListData();
  },

  beforeRender: function() {
    if (this.isLoading) {
      bookedby.app.startLoading();
      this.$el.html('');
      return false;
    }

    return true;

    return this.model != null;

    /*if (this.renderVersion == this.dataVersion) {
      return false;
    }
    this.renderVersion = this.dataVersion;
    return true;*/
  },

  afterRender: function() {
    if (!this.isLoading) {
      bookedby.app.finishLoading();
    }

    this.applyBindings();

  },

  cleanup: function() {
    console.log("clearing wait board refresh interval");
    if (this.currentWaitTimesTimeout) {
      clearTimeout(this.currentWaitTimesTimeout);
      this.currentWaitTimesTimeout = null;
    }
    this.disposeWaitTimesTimeout = true;

    this.removeBindings();
  },

  setWaitTimer: function(model) {
    var isNoResponseFromAPI = _.isNull(model);

    var isFeatureEnabled = model && model.get('isFeatureEnabled');

    // TODO do we need to check on # of queue items before refreshing (or on presence of this guest's appointments in the queue)?
    // TODO confirm that it's ok to just re-draw in case of no API response
    if (isNoResponseFromAPI || isFeatureEnabled) {
      var refreshIntervalSec = 60; //TODO:: configure??
      if (refreshIntervalSec > 0) {
        console.log("setting wait board refresh interval to", refreshIntervalSec, "sec");
        this.currentWaitTimesTimeout = setTimeout(_.bind(this.setWaitListData, this), refreshIntervalSec * 1000);
      }
    }
  },

  // TODO - figure out could it be called in other components?
  fixContentHeight: function () {
    var topBarHeight = $('.top-bar').height();
    /* - 40 px is to account for top and bottom margins of the outer container */
    var height = $(window).height() - topBarHeight - 40;
    var $elem = this.$el;

    $elem.css('height', height);

    // temporary fix for Chrome's scroll issue where the user is unable to scroll until he resizes the window
    $elem.css('overflow', 'auto');
    _.delay(function() { $elem.css('overflow', ''); }, 300);
  },

  hasChanges: function() {
    return false;
  },

  setWaitListData: function() {
    if (this.disposeWaitTimesTimeout) {
      return;
    }
    this.isLoading = true;

    $.ajax({
      url: bookedby.routes.BOOKING.PUBLIC_WAIT_BOARD,
      data: {
        store: this.store
      },
      method: 'GET',
      cache: false,
      dataType: 'json',
      success: _.bind(function(data) {
        this.model.bindModel(data);

        if (data.behavior == 'redirect') {
          bookedby.app.navigateTo('start-wait-list');
        }

        this.isLoading = false;
        this.setWaitTimer(this.model);
        //this.dataVersion += 1;
        //this.render();
      }, this),
      error: _.bind(function(jqXHR, textStatus, textError) {
        bookedby.app.logAPIError(textError);
        this.setWaitTimer(null);
      }, this)
    });
  },
});

module.exports = StoreWaitBoardView;
